module.exports = __webpack_public_path__ + "static/media/santa-rita-login.d48de997.svg";